export const colWidth = (widthInPixels:number) => ({ width: `${widthInPixels}px` })
